import axios from "axios";
import endpoints from "../utils/endpoints";
import { accessToken } from "../utils/token";
import fileDownload from "js-file-download";

const getAllEvent = async (params: any) => {
  const url = endpoints.EVENT;

  const { data: response } = await axios.get(url, {
    headers: {
      Authorization: accessToken,
    },
    params: params,
  });

  return response;
};

const getAllPublicEvent = async (params: any) => {
  const url = endpoints.PUBLIC_EVENT;

  const { data: response } = await axios.get(url, { params: params });

  return response;
};

const viewEventDetail = async (id: any) => {
  if (id) {
    const url = endpoints.VIEW_EVENT(id);
    const { data: response } = await axios.get(url, {
      headers: {
        Authorization: accessToken,
      },
    });
    return response;
  }
};

const viewPublicEventDetail = async (params: any) => {
  if (params.id) {
    const url = endpoints.VIEW_PUBLIC_EVENT(params.id);
    const { data: response } = await axios.get(url, {
      headers: {
        Authorization: accessToken,
      },
      params: { is_category: params.is_category },
    });
    return response;
  }
};

const createEvent = async (params: any) => {
  const url = endpoints.CREATE_EVENT;
  const { data: response } = await axios.post(url, params, {
    headers: {
      Authorization: accessToken,
    },
  });

  return response;
};

const deleteEvent = async (id: number) => {
  const url = endpoints.DELETE_EVENT(id);

  const { data: response } = await axios.delete(url, {
    headers: {
      Authorization: accessToken,
    },
  });
  return response;
};

const updateEvent = async (params: any) => {
  const url = endpoints.VIEW_EVENT(params.get("id"));
  const { data: response } = await axios.patch(url, params, {
    headers: {
      Authorization: accessToken,
    },
  });
  return response;
};

const downloadReport = async (params: any) => {
  if (parseInt(params.id)) {
    const url = endpoints.EVENT_REPORT(params.id);
    await axios
      .get(url, {
        headers: {
          Authorization: accessToken,
          ContentType:
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        },
        responseType: "arraybuffer",
      })
      .then((res) => {
        var blob = new Blob([res.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        fileDownload(blob, `event_report_${params.name}.xlsx`);
      });
  }
};

const downloadSales = async (params: any) => {
  if (parseInt(params.id)) {
    const url = endpoints.EVENT_SALES(params.id);
    await axios
      .get(url, {
        headers: {
          Authorization: accessToken,
          ContentType:
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        },
        responseType: "arraybuffer",
      })
      .then((res) => {
        var blob = new Blob([res.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        fileDownload(blob, `event_sales_${params.name}.xlsx`);
      });
  }
};

const downloadEventInvitations = async (event_id: string) => {
  const url = endpoints.EVENT + `/invitations/${event_id}`;
  const { data: response } = await axios.get(url, {
    headers: {
      Authorization: accessToken,
      ContentType:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    },
    responseType: "arraybuffer",
  });

  const blob = new Blob([response], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  fileDownload(blob, `invitations-event-${event_id}.xlsx`);
  return blob
};

const getEventFormConfig = async (slug: string) => {
  const url = endpoints.PUBLIC_EVENT_FORM_CONFIG(slug);
  const { data: response } = await axios.get(url);
  return response;
};

const service = {
  getAllEvent,
  getAllPublicEvent,
  viewEventDetail,
  viewPublicEventDetail,
  createEvent,
  deleteEvent,
  updateEvent,
  downloadReport,
  downloadSales,
  downloadEventInvitations,
  getEventFormConfig,
};

export default service;
